import { useEffect, useState } from 'react';

const TIMEOUT = 500;

export const useDebounce = <T>(inbound: T, delay = TIMEOUT) => {
  const [value, setValue] = useState<T>(inbound);

  useEffect(() => {
    const timerId = setTimeout(() => setValue(inbound), delay);
    return () => clearTimeout(timerId);
  }, [inbound, delay]);

  return value;
};
